import { api } from '@/api/client';
import {
  studioAddRequestFormSchema,
  studioAddRequestResponseSchema,
} from '@/lib/validation';
import type { StudioAddRequestFormValues } from '@/lib/validation';
import type { StudioAddRequestResponse } from '@/types';

export function submitStudioAddRequest(input: StudioAddRequestFormValues): Promise<StudioAddRequestResponse> {
  const values = studioAddRequestFormSchema.parse(input);

  return api('/studio-add-requests', {
    method: 'POST',
    body: JSON.stringify(values),
    responseSchema: studioAddRequestResponseSchema,
  });
}
